export const createTicket = {
  apiUrl: "/ticket/",
  header: "Content-Type: application/json",
};
